///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component } from "@angular/core";

@Component({
    templateUrl: "./application.module.component.html",
    styleUrls: ["./application.module.component.css"],
})
export class ApplicationModuleComponent {
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/application.module.component.ts